import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SearchEmployee from '../../components/SearchEmployee';
import SearchRambo from '../../components/SearchRambo';
import axios from 'axios';
import { dateFormat, endpoint, endpointApi } from '../../utils';
import { logout } from '../../redux/actions/auth.action';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/actions/loader.action';
import { getTaskRambos } from '../../redux/actions/task.action';

import "chart.js/auto";
import { Line } from 'react-chartjs-2';

export default function TaskRamboPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const taskRambos = useSelector(state => state.taskRambos);

    const [URLSearchParams] = useSearchParams();
    const _task = URLSearchParams.get('task');
    const _start_date = URLSearchParams.get('start_date');
    const _end_date = URLSearchParams.get('end_date');

    const [isNoisyData, setIsNoisyData] = useState(false);
    const addModalRef = useRef(null);
    const editModalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const detailsTaskRamboModalRef = useRef(null);
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);
    const [taskRambo, setTaskRambo] = useState(null);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [type, setType] = useState("");

    const [detailOptions, setDetailOptions] = useState(null);
    const [tasks, setTasks] = useState(null);

    const [date, setDate] = useState("");
    const [employee, setEmployee] = useState(null);
    const [task, setTask] = useState("");
    const [quantityShort, setQuantityShort] = useState("");
    const [quantityLong, setQuantityLong] = useState("");
    const [wasteShort, setWasteShort] = useState("");
    const [wasteLong, setWasteLong] = useState("");
    const [rambo, setRambo] = useState(null);
    const [originEmployee, setOriginEmployee] = useState(null);
    const [description, setDescription] = useState("");
    
    const [isDateTouched, setIsDateTouched] = useState(false);
    const [isTaskTouched, setIsTaskTouched] = useState(false);
    const [isQuantityShortTouched, setIsQuantityShortTouched] = useState(false);
    const [isQuantityLongTouched, setIsQuantityLongTouched] = useState(false);
    const [isWasteShortTouched, setIsWasteShortTouched] = useState(false);
    const [isWasteLongTouched, setIsWasteLongTouched] = useState(false);
    
    const [errors, setErrors] = useState(null);
    const [data, setData] = useState(null);
    const [config, setConfig] = useState(null);
    
    const [ids, setIds] = useState([]);
    const checkboxRefs = useRef([]);

    useEffect(() => {
        setStartDate(_start_date !== null && _start_date !== undefined ? _start_date : "");
        setEndDate(_end_date !== null && _end_date !== undefined ? _end_date : "");
        setType(_task !== null && _task !== undefined ? _task : "");
    }, [location, _start_date, _end_date, _task]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        if(task !== 'SORTING'){
            setQuantityShort(0);
        }
    }, [task]);

    useEffect(() => {
        let url = '/tasks/rambos';
        if(startDate && endDate && endDate.length > 0 && endDate.length > 0){
            const startDateTemp = new Date(startDate);
            const endDateTemp = new Date(endDate);

            if(endDateTemp >= startDateTemp) {
                URLSearchParams.set('start_date', startDate);
                URLSearchParams.set('end_date', endDate);
                const search = URLSearchParams.toString();
                if(search.length > 0)
                    url += "?" + search;
                navigate(url);  
            }
        }
    }, [startDate, endDate, navigate, URLSearchParams]);
    
    useEffect(() => {
        let url = '/tasks/rambos';
        if(type.length > 0){
            URLSearchParams.set('task', type);
        }else{
            URLSearchParams.delete('task');
        }
        const search = URLSearchParams.toString();
        if(search.length > 0)
            url += "?" + search;
        navigate(url);
    }, [type, navigate, URLSearchParams]);

    useEffect(() => {
        if(modal === null || modal === 'details'){
            setDate("");
            setEmployee(null);
            setTask("");
            setQuantityShort("");
            setQuantityLong("");
            setWasteShort("");
            setWasteLong("");
            setRambo(null);
            setOriginEmployee(null);
            setDescription("");
            
            setIsDateTouched(false);
            setIsTaskTouched(false);
            setIsQuantityShortTouched(false);
            setIsQuantityLongTouched(false);
            setIsWasteShortTouched(false);
            setIsWasteLongTouched(false);
        }
        if(modal === null){
            setTaskRambo(null);
            setDetailOptions(null);
        }
    }, [modal]);

    useEffect(() => {
        if(taskRambo && modal === 'update'){
            setDate(taskRambo.date);
            setEmployee(taskRambo.employee);
            setTask(taskRambo.task);
            setQuantityShort(taskRambo.quantity_short !== null ? taskRambo.quantity_short : "");
            setQuantityLong(taskRambo.quantity_long !== null ? taskRambo.quantity_long : "");
            setWasteShort(taskRambo.waste_short !== null ? taskRambo.waste_short : "");
            setWasteLong(taskRambo.waste_long !== null ? taskRambo.waste_long : "");
            setRambo(taskRambo.rambo);
            setOriginEmployee(taskRambo.origin_employee);
            setDescription(taskRambo.description ? taskRambo.description : "");
        }
    }, [taskRambo, modal]);

    useEffect(() => {
        const clickOutsideModal = (e) => {
            if((addModalRef.current === e.target && addModalRef.current.classList.contains('active')) || (editModalRef.current === e.target && editModalRef.current.classList.contains('active')) || (detailsModalRef.current === e.target && detailsModalRef.current.classList.contains('active')) || (detailsTaskRamboModalRef.current === e.target && detailsTaskRamboModalRef.current.classList.contains('active')) || e.target.classList.contains('_modal-close')){
                setModal(null);
            }
        }

        document.addEventListener('click', clickOutsideModal);

        return () => {
            document.removeEventListener('click', clickOutsideModal);
        }
    }, []);

    const handleAddTask = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));

        setErrors(null);
        const data = new FormData(e.target);

        await axios.post(`${ endpointApi }task-rambos`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        setModal('details-task-rambo');
                        setTaskRambo(data);
                        if(isNoisyData){
                            dispatch(getTaskRambos(location, navigate));
                        }else{
                            loadData();
                        }
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleEditTask = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));

        setErrors(null);
        const data = new FormData(e.target);

        await axios.put(`${ endpointApi }task-rambos/${ taskRambo?.id }`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        setModal('details-task-rambo');
                        setTaskRambo(data);
                        if(isNoisyData){
                            dispatch(getTaskRambos(location, navigate));
                        }else{
                            loadData();
                        }
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    const getLabel = (key) => {
        switch (key) {
            case 'SORTING':
                return 'Triage';
            case 'CUTTING':
                return 'Coupe';
            case 'SORTING_AFTER_CUTTING':
                return 'Triage après coupe';
            case 'CLEANING':
                return 'Nettoyage';
            case 'FINAL_INSPECTION':
                return 'Vérification finale';
            case 'BOXING':
                return 'Mise en boîte';
            default:
                return "";
        }
    }

    useEffect(() => {
        if(data){
            const labels = Object.keys(data.data["SORTING"] || {});
            const datasets = Object.keys(data.data).map((key, index) => {
                const values = Object.values(data.data[key] || {});
                return {
                    label: getLabel(key),
                    data: values.length === labels.length ? values : Array(labels.length).fill(0), // S'assure d'avoir la même longueur
                    fill: false,
                    borderColor: `hsl(${index * 60}, 70%, 50%)`,
                    tension: 0.1
                };
            });

            const config = {
                labels: labels.map(date => {
                    return dateFormat(date, 'ddmm');
                }),
                datasets: datasets,
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top'
                        },
                        title: {
                            display: true,
                            text: 'Production des différentes étapes'
                        }
                    },
                    scales: {
                        x: {
                            title: {
                                display: true,
                                text: 'Date'
                            }
                        },
                        y: {
                            title: {
                                display: true,
                                text: 'Valeur de production'
                            }
                        }
                    }
                }
            };

            setConfig(config);
        }else{
            setConfig(null);
        }
    }, [data]);

    const getDetails = async (task, date, nb) => {
        if(parseInt(nb) > 0){
            setTasks(null);
            dispatch(setLoading(true));
            await axios.get(`${ endpointApi }task-rambos/${ task }/${ date }`, {
                            headers: {
                                'Authorization': `Bearer ${ jwt_access }`
                            } 
                        })
                        .then(({ data }) => {
                            setDetailOptions({
                                task,
                                date
                            });
                            setTasks(data);
                            setModal('details');
                        })
                        .catch(err => {
                            if(err.response.status === 401){
                                dispatch(logout(location.pathname + location.search, navigate));
                            }
                        })
                        .finally(() => {
                            dispatch(setLoading(false));
                        });
        }
    }

    const loadData = useCallback(async () => {
        dispatch(setLoading(true));
        setData(null);
        await axios.get(`${ endpointApi }task-rambos/data${ location.search }`, {
                        headers: {
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        setData(data);
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }, [location, dispatch, jwt_access, navigate]);

    useEffect(() => {
        if(isNoisyData){
            dispatch(getTaskRambos(location, navigate));
        }else{
            loadData();
        }
    }, [location, dispatch, navigate, isNoisyData, jwt_access, loadData]);

    // DELETE
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        if(checked){
            setIds((prevValues) => [...prevValues, value]);
        }else{
            setIds((prevValues) => prevValues.filter((item) => item !== value));
        }
    }

    const deleteSelection = async () => {
        dispatch(setLoading(false));
        await axios.delete(`${ endpointApi }task-rambos?ids=${ ids.join(',') }`, {
                    headers: {
                        "Authorization": `Bearer ${ jwt_access }`
                    }        
                })
                .then(({ data }) => {
                    setIds([]);
                    dispatch(getTaskRambos(location, navigate));
                })
                .catch(err => {
                    setIds([]);
                    if(err.response.status === 401){
                        dispatch(logout(location.pathname + location.search, navigate));
                    }
                })
                .finally(() => {
                    dispatch(setLoading(false));
                });
    }
    
    useEffect(() => {
        if(ids.length === 0){
            checkboxRefs.current.forEach((checkbox) => {
                if(checkbox) {
                    checkbox.checked = false;
                }
            });
        }
    }, [ids]);

    return (
        <HelmetProvider>
            <Helmet>
                <title>Asa Rambos - Société Mikalo</title>
            </Helmet>

            <div className='title d-flex justify-content-between'>
                <h1>Asa Rambos</h1>
                <button type='button' className='btn btn-primary' onClick={ () => setModal("add") }><i className='fa fa-plus'></i> Ajouter</button>
            </div>

            <div className="form mb-2 d-flex align-items-center justify-content-between">
                <div className='filter'>
                    <div className='d-flex align-items-center'>
                        <div className='me-4'>
                            <label htmlFor='start_date'>De :</label>
                            <input style={{ width: "160px" }} type='date' id='start_date' value={ startDate } className='form-control' required onChange={ (e) => setStartDate(e.target.value) } />
                        </div>
                        <div className='me-4'>
                            <label htmlFor='end_date'>À :</label>
                            <input style={{ width: "160px" }} type='date' id='end_date' value={ endDate } className='form-control' required onChange={ (e) => setEndDate(e.target.value) } />
                        </div>
                        <div className='me-4'>
                            <label htmlFor='end_date'>Type de tâche</label>
                            <select style={{ width: "160px" }} id='type' value={ type } className='form-control' required onChange={ (e) => setType(e.target.value) }>
                                <option value="">Tous</option>
                                <option value="SORTING">Triage</option>
                                <option value="CUTTING">Coupe</option>
                                <option value="SORTING_AFTER_CUTTING">Triage après coupe</option>
                                <option value="CLEANING">Nettoyage</option>
                                <option value="FINAL_INSPECTION">Vérification finale</option>
                                <option value="BOXING">Mise en boîte</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="form">
                    <label className='mycheckbox'>
                        <input type='checkbox' checked={ isNoisyData } onChange={ (e) => setIsNoisyData(e.target.checked) } />
                        <div></div>
                        Données bruites
                    </label>
                </div>
            </div>

            <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        <h4>Ajouter une tâche journalière</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleAddTask }>
                            <div className='mb-3'>
                                <label htmlFor='date' className='required'>Date</label>
                                <input type='date' id='date' name='date' placeholder='Date' className='form-control' required value={ date } onChange={ (e) => setDate(e.target.value) } onBlur={ () => setIsDateTouched(true) } />
                                { isDateTouched && date.length === 0 && <div className='form-error'>Veuillez sélectionner la date.</div> }
                                { errors && errors.date && <div className='form-error'>{ errors.date[0] }</div> }
                            </div>
                            
                            <div className='mb-3'>
                                <label htmlFor='employee_id' className='required'>Employé</label>
                                <input type='hidden' name='employee_id' className='form-control' value={ employee ? employee.id : "" } />
                                <SearchEmployee id='employee_id' required={ true } reset={ modal !== 'add' } updateEmployee={ setEmployee } defaultValue={ employee } />
                                { errors && errors.employee_id && <div className='form-error'>{ errors.employee_id[0] }</div> }
                            </div>

                            <div className='mb-3'>
                                <label htmlFor='task' className='required'>Tâche</label>
                                <select id='task' name='task' required className='form-control' value={ task } onChange={ (e) => setTask(e.target.value) } onBlur={ () => setIsTaskTouched(true) }>
                                    <option value="">Sélectionner</option>
                                    <option value="SORTING">Triage</option>
                                    <option value="CUTTING">Coupe</option>
                                    <option value="SORTING_AFTER_CUTTING">Triage après coupe</option>
                                    <option value="CLEANING">Nettoyage</option>
                                    <option value="FINAL_INSPECTION">Vérification finale</option>
                                    <option value="BOXING">Mise en boîte</option>
                                </select>
                                { isTaskTouched && task.length === 0 && <div className='form-error'>Veuillez sélectionner la tâche.</div> }
                                { errors && errors.task && <div className='form-error'>{ errors.task[0] }</div> }
                            </div>
                            
                            { task.length > 0 && <>
                            <h6>Quantité</h6>
                            <div className='row'>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` } style={{ display: task !== 'SORTING' ? 'none' : 'block' }}>
                                    <label htmlFor='quantity_short' className='required'>{ task === 'SORTING' ? 'FOHY' : 'Quantité' }</label>
                                    <input type='number' id='quantity_short' min={ 0 } step={ 1 } name='quantity_short' placeholder={ task === 'SORTING' ? 'FOHY' : 'Quantité' } className='form-control' value={ quantityShort } onChange={ (e) => setQuantityShort(e.target.value) } onBlur={ () => setIsQuantityShortTouched(true) } />
                                    { isQuantityShortTouched && quantityShort.length === 0 && <div className='form-error'>Veuillez saisir la quantité{ task === 'SORTING' ? ' (FOHY)' : '' }.</div> }
                                    { errors && errors.quantity_short && <div className='form-error'>{ errors.quantity_short[0] }</div> }
                                </div>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` }>
                                    <label htmlFor='quantity_long' className='required'>{ task === 'SORTING' ? 'LAVA' : 'Quantité' }</label>
                                    <input type='number' id='quantity_long' min={ 0 } step={ 1 } name='quantity_long' placeholder={ task === 'SORTING' ? 'LAVA' : 'Quantité' } className='form-control' value={ quantityLong } onChange={ (e) => setQuantityLong(e.target.value) } onBlur={ () => setIsQuantityLongTouched(true) } />
                                    { isQuantityLongTouched && quantityLong.length === 0 && <div className='form-error'>Veuillez saisir la quantité{ task === 'SORTING' ? ' (LAVA)' : '' }.</div> }
                                    { errors && errors.quantity_long && <div className='form-error'>{ errors.quantity_long[0] }</div> }
                                </div>
                            </div>
                                    
                            { task !== "CUTTING" && task !== 'BOXING' && <>
                            <h6>Déchets</h6>
                            <div className='row'>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` } style={{ display: task !== 'SORTING' ? 'none' : 'block' }}>
                                    <label htmlFor='waste_short' className='required'>{ task === 'SORTING' ? 'FOHY' : 'Nb déchets' }</label>
                                    <input type='number' id='waste_short' min={ 0 } step={ 1 } name='waste_short' placeholder={ task === 'SORTING' ? 'FOHY' : 'Nb déchets' } className='form-control' value={ wasteShort } onChange={ (e) => setWasteShort(e.target.value) } onBlur={ () => setIsWasteShortTouched(true) } />
                                    { isWasteShortTouched && wasteShort.length === 0 && <div className='form-error'>Veuillez saisir le nombre de déchets{ task === 'SORTING' ? ' (FOHY)' : '' }.</div> }
                                    { errors && errors.waste_short && <div className='form-error'>{ errors.waste_short[0] }</div> }
                                </div>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` }>
                                    <label htmlFor='waste_long' className='required'>{ task === 'SORTING' ? 'LAVA' : 'Nb déchets' }</label>
                                    <input type='number' id='waste_long' min={ 0 } step={ 1 } name='waste_long' placeholder={ task === 'SORTING' ? 'LAVA' : 'Nb déchets' } className='form-control' value={ wasteLong } onChange={ (e) => setWasteLong(e.target.value) } onBlur={ () => setIsWasteLongTouched(true) } />
                                    { isWasteLongTouched && wasteLong.length === 0 && <div className='form-error'>Veuillez saisir le nombre de déchets{ task === 'SORTING' ? ' (LAVA)' : '' }.</div> }
                                    { errors && errors.waste_long && <div className='form-error'>{ errors.waste_long[0] }</div> }
                                </div>
                            </div>
                            </> }

                            <div className='mb-3'>
                                <label htmlFor='rambo_id' className='required'>Rambo</label>
                                <input type='hidden' name='rambo_id' className='form-control' value={ rambo ? rambo.id : "" } />
                                <SearchRambo updateRambo={ setRambo } id='tambo_id' required={ true } reset={ modal !== "add" } defaultValue={ rambo } />
                                { errors && errors.rambo_id && <div className='form-error'>{ errors.rambo_id[0] }</div> }
                            </div>
                                
                            { task !== "SORTING" && task !== "CUTTING" &&
                            <div className='mb-3'>
                                <label htmlFor='origin_employee_id' className='required'>Employé origine</label>
                                <input type='hidden' name='origin_employee_id' className='form-control' value={ employee ? employee.id : "" } />
                                <SearchEmployee id='origin_employee_id' reset={ modal !== 'add' } updateEmployee={ setOriginEmployee } defaultValue={ originEmployee } />
                                { errors && errors.origin_employee_id && <div className='form-error'>{ errors.origin_employee_id[0] }</div> }
                            </div> }

                            <div className='mb-3'>
                                <label htmlFor='description'>Description</label>
                                <textarea id='description' value={ description } onChange={ (e) => setDescription(e.target.value) } className='form-control' placeholder='Description'></textarea>
                                { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                            </div> </> }

                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    date.length === 0 || employee === null || task.length === 0 || rambo === null || quantityLong.length === 0 || (task !== 'CUTTING' && wasteLong.length === 0)
                                }><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ editModalRef } className={ `_modal${ modal === 'update' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        <h4>Modifier une tâche journalière</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleEditTask }>
                            <div className='mb-3'>
                                <label htmlFor='_date' className='required'>Date</label>
                                <input type='date' id='_date' name='date' placeholder='Date' className='form-control' required value={ date } onChange={ (e) => setDate(e.target.value) } onBlur={ () => setIsDateTouched(true) } />
                                { isDateTouched && date.length === 0 && <div className='form-error'>Veuillez sélectionner la date.</div> }
                                { errors && errors.date && <div className='form-error'>{ errors.date[0] }</div> }
                            </div>
                            
                            <div className='mb-3'>
                                <label htmlFor='_employee_id' className='required'>Employé</label>
                                <input type='hidden' name='employee_id' className='form-control' value={ employee ? employee.id : "" } />
                                <SearchEmployee required={ true } id='_employee_id' reset={ modal !== 'update' } updateEmployee={ setEmployee } defaultValue={ employee } />
                                { errors && errors.employee_id && <div className='form-error'>{ errors.employee_id[0] }</div> }
                            </div>

                            <div className='mb-3'>
                                <label htmlFor='_task' className='required'>Tâche</label>
                                <select id='_task' name='task' required className='form-control' value={ task } onChange={ (e) => setTask(e.target.value) } onBlur={ () => setIsTaskTouched(true) }>
                                    <option value="">Sélectionner</option>
                                    <option value="SORTING">Triage</option>
                                    <option value="CUTTING">Coupe</option>
                                    <option value="SORTING_AFTER_CUTTING">Triage après coupe</option>
                                    <option value="CLEANING">Nettoyage</option>
                                    <option value="FINAL_INSPECTION">Vérification finale</option>
                                    <option value="BOXING">Mise en boîte</option>
                                </select>
                                { isTaskTouched && task.length === 0 && <div className='form-error'>Veuillez sélectionner la tâche.</div> }
                                { errors && errors.task && <div className='form-error'>{ errors.task[0] }</div> }
                            </div>
                            
                            { task.length > 0 && <>
                            <h6>Quantité</h6>
                            <div className='row'>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` } style={{ display: task !== 'SORTING' ? 'none' : 'block' }}>
                                    <label htmlFor='quantity_short' className='required'>{ task === 'SORTING' ? 'FOHY' : 'Quantité' }</label>
                                    <input type='number' id='quantity_short' min={ 0 } step={ 1 } name='quantity_short' placeholder={ task === 'SORTING' ? 'FOHY' : 'Quantité' } className='form-control' value={ quantityShort } onChange={ (e) => setQuantityShort(e.target.value) } onBlur={ () => setIsQuantityShortTouched(true) } />
                                    { isQuantityShortTouched && quantityShort.length === 0 && <div className='form-error'>Veuillez saisir la quantité{ task === 'SORTING' ? ' (FOHY)' : '' }.</div> }
                                    { errors && errors.quantity_short && <div className='form-error'>{ errors.quantity_short[0] }</div> }
                                </div>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` }>
                                    <label htmlFor='quantity_long' className='required'>{ task === 'SORTING' ? 'LAVA' : 'Quantité' }</label>
                                    <input type='number' id='quantity_long' min={ 0 } step={ 1 } name='quantity_long' placeholder={ task === 'SORTING' ? 'LAVA' : 'Quantité' } className='form-control' value={ quantityLong } onChange={ (e) => setQuantityLong(e.target.value) } onBlur={ () => setIsQuantityLongTouched(true) } />
                                    { isQuantityLongTouched && quantityLong.length === 0 && <div className='form-error'>Veuillez saisir la quantité{ task === 'SORTING' ? ' (LAVA)' : '' }.</div> }
                                    { errors && errors.quantity_long && <div className='form-error'>{ errors.quantity_long[0] }</div> }
                                </div>
                            </div>
                                    
                            { task !== "CUTTING" && task !== 'BOXING' && <>
                            <h6>Déchets</h6>
                            <div className='row'>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` } style={{ display: task !== 'SORTING' ? 'none' : 'block' }}>
                                    <label htmlFor='waste_short' className='required'>{ task === 'SORTING' ? 'FOHY' : 'Nb déchets' }</label>
                                    <input type='number' id='waste_short' min={ 0 } step={ 1 } name='waste_short' placeholder={ task === 'SORTING' ? 'FOHY' : 'Nb déchets' } className='form-control' value={ wasteShort } onChange={ (e) => setWasteShort(e.target.value) } onBlur={ () => setIsWasteShortTouched(true) } />
                                    { isWasteShortTouched && wasteShort.length === 0 && <div className='form-error'>Veuillez saisir le nombre de déchets{ task === 'SORTING' ? ' (FOHY)' : '' }.</div> }
                                    { errors && errors.waste_short && <div className='form-error'>{ errors.waste_short[0] }</div> }
                                </div>
                                <div className={ `${ task === 'CUTTING' || task === 'BOXING' ? 'col-12' : 'col-6' } mb-3` }>
                                    <label htmlFor='waste_long' className='required'>{ task === 'SORTING' ? 'LAVA' : 'Nb déchets' }</label>
                                    <input type='number' id='waste_long' min={ 0 } step={ 1 } name='waste_long' placeholder={ task === 'SORTING' ? 'LAVA' : 'Nb déchets' } className='form-control' value={ wasteLong } onChange={ (e) => setWasteLong(e.target.value) } onBlur={ () => setIsWasteLongTouched(true) } />
                                    { isWasteLongTouched && wasteLong.length === 0 && <div className='form-error'>Veuillez saisir le nombre de déchets{ task === 'SORTING' ? ' (LAVA)' : '' }.</div> }
                                    { errors && errors.waste_long && <div className='form-error'>{ errors.waste_long[0] }</div> }
                                </div>
                            </div>
                            </> }

                            <div className='mb-3'>
                                <label htmlFor='_rambo_id' className='required'>Rambo</label>
                                <input type='hidden' name='rambo_id' className='form-control' value={ rambo ? rambo.id : "" } />
                                <SearchRambo updateRambo={ setRambo } id='_rambo_id' required={ true } reset={ modal !== "update" } defaultValue={ rambo } />
                                { errors && errors.rambo_id && <div className='form-error'>{ errors.rambo_id[0] }</div> }
                            </div>
                            
                            { task !== "SORTING" && task !== "CUTTING" &&
                            <div className='mb-3'>
                                <label htmlFor='_origin_employee_id' className='required'>Employé origine</label>
                                <input type='hidden' name='origin_employee_id' className='form-control' value={ employee ? employee.id : "" } />
                                <SearchEmployee id='_origin_employee_id' reset={ modal !== 'add' } updateEmployee={ setOriginEmployee } defaultValue={ originEmployee } />
                                { errors && errors.origin_employee_id && <div className='form-error'>{ errors.origin_employee_id[0] }</div> }
                            </div> }

                            <div className='mb-3'>
                                <label htmlFor='_description'>Description</label>
                                <textarea id='_description' value={ description } onChange={ (e) => setDescription(e.target.value) } className='form-control' placeholder='Description'></textarea>
                                { errors && errors.description && <div className='form-error'>{ errors.description[0] }</div> }
                            </div>
                            </> }

                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    date.length === 0 || employee === null || task.length === 0 || rambo === null || quantityLong.length === 0 || (task !== 'CUTTING' && wasteLong.length === 0)
                                }><i className="fa fa-save"></i> Mettre à jour</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ detailsTaskRamboModalRef } className={ `_modal${ modal === 'details-task-rambo' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    { taskRambo && 
                    <div className='_modal-head'>
                        <h4>Détail tâche "{ getLabel(taskRambo.task) }" du { dateFormat(taskRambo.date) }</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div> }
                    <div className='_modal-body'>
                    { taskRambo && <>
                        <div className='mb-3'>
                            <div className='_label'>Date</div>
                            <div className='_value'>{ dateFormat(taskRambo.date) }</div>
                        </div>
                        
                        <div className='mb-3'>
                            <div className='_label'>Employé</div>
                            <div className='_value'>{ taskRambo.employee ? taskRambo.employee.last_name + " " + taskRambo.employee.first_name : "-" }</div>
                        </div>

                        <div className='mb-3'>
                            <div className='_label'>Tâche</div>
                            <div className='_value'>{ getLabel(taskRambo.task) }</div>
                        </div>

                        <h6># Quantité</h6>
                        { taskRambo.task === "SORTING" ?
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>FOHY</div>
                                <div className='_value'>{ taskRambo.quantity_short }</div>
                            </div>
                            <div className='col-6 mb-3'>
                                <div className='_label'>LAVA</div>
                                <div className='_value'>{ taskRambo.quantity_long }</div>
                            </div>
                        </div>
                        :
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <div className='_label'>Quantité</div>
                                <div className='_value'>{ taskRambo.quantity_long }</div>
                            </div>
                        </div> }
                        <h6># Déchets</h6>
                        { taskRambo.task === "SORTING" ?
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>FOHY</div>
                                <div className='_value'>{ taskRambo.waste_short }</div>
                            </div>
                            <div className='col-6 mb-3'>
                                <div className='_label'>LAVA</div>
                                <div className='_value'>{ taskRambo.waste_long }</div>
                            </div>
                        </div>
                        :
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <div className='_label'>Nb de déchets</div>
                                <div className='_value'>{ taskRambo.waste_long }</div>
                            </div>
                        </div>
                        }

                        { taskRambo.originEmployee &&
                        <div className='mb-3'>
                            <div className='_label'>Origine</div>
                            <div className='_value'>{ taskRambo.origin_employee ? taskRambo.origin_employee.last_name + " " + taskRambo.origin_employee.first_name : "-" }</div>
                        </div> }

                        <div className='mb-3'>
                            <div className='_label'>Description</div>
                            <div className='_value'>{ taskRambo.description ?? '-' }</div>
                        </div>
                    </> }
                    </div>
                </div>
            </div>
            
            <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    { detailOptions && 
                    <div className='_modal-head'>
                        <h4>Détail "{ getLabel(detailOptions.task) }" du { dateFormat(detailOptions.date) }</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div> }
                    <div className='_modal-body'>
                        { tasks && 
                        <table className='table table-striped'>
                            <thead>
                                <tr>
                                    <th>Employé</th>
                                    <th>Détails</th>
                                </tr>
                            </thead>
                            <tbody>
                                { tasks.map((item,index) => {
                                    return(
                                        <tr key={ index }>
                                            <th>
                                                { item.employee.last_name } { item.employee.first_name }
                                                <ul style={{ fontWeight: "500" }}>
                                                    <li>Rambo: { item.rambo.code }</li>
                                                    { item.origin_employee &&
                                                    <li>Origine: { item.origin_employee.last_name } { item.origin_employee.first_name }</li> }
                                                </ul>
                                            </th>
                                            <td>
                                                <table className='table table-striped'>
                                                    <thead className='text-center'>
                                                        <tr>
                                                            <th colSpan={ item.task === 'SORTING' ? 2 : 1 }>Quantité</th>
                                                            <th colSpan={ item.task === 'SORTING' ? 2 : 1 }>Déchet</th>
                                                        </tr>
                                                        { item.task === 'SORTING' &&
                                                        <tr>
                                                            <th>FOHY</th>
                                                            <th>LAVA</th>
                                                            <th>FOHY</th>
                                                            <th>LAVA</th>
                                                        </tr> }
                                                    </thead>
                                                    <tbody>
                                                        { item.task === 'SORTING' ? 
                                                        <tr className='text-center'>
                                                            <td>{ item.quantity_short }</td>
                                                            <td>{ item.quantity_long }</td>
                                                            <td>{ item.waste_short ?? '-' }</td>
                                                            <td>{ item.waste_long ?? '-' }</td>
                                                        </tr>
                                                        :
                                                        <tr className='text-center'>
                                                            <td>{ item.quantity_long }</td>
                                                            <td>{ item.waste_long ?? '-' }</td>
                                                        </tr> }
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    )
                                }) }
                            </tbody>
                        </table> }
                    </div>
                </div>
            </div>

            { isNoisyData ? <>
            { ids.length > 0 && 
            <div className='mb-3'>
                <button type='button' onClick={ deleteSelection } className='btn btn-red'><i className='fa fa-trash'></i> Supprimer la sélection</button>
            </div> }

            <div className='box'>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th width="45"></th>
                            <th witdh="120">Date</th>
                            <th width="50px"></th>
                            <th>Employé</th>
                            <th>Tâche</th>
                            <th className='text-center' colSpan={ 2 }>Quantité</th>
                            <th className='text-center' colSpan={ 2 }>Nb déchets</th>
                            <th>Rambo</th>
                            <th width="75" className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { taskRambos && taskRambos.loading && <tr><td colSpan={ 11 }>Chargement...</td></tr> }
                        { taskRambos && taskRambos.loading === false && taskRambos.data && taskRambos.data.total === 0 && <tr><td colSpan={ 11 }>Aucun élément trouvé</td></tr> }
                        { taskRambos && taskRambos.loading === false && taskRambos.data && taskRambos.data.data && taskRambos.data.data.map((item, index) => {
                        return(
                            <tr key={ index }>
                                <td>
                                    <label>
                                        <input type='checkbox' checked={ ids.includes(String(item.id)) } ref={(el) => (checkboxRefs.current[index] = el)} value={ item.id } onChange={ handleCheckboxChange } />
                                        <span></span>
                                    </label>
                                </td>
                                <td>{ dateFormat(item.date) }</td>
                                <td>
                                    <div className='avatar avatar-32x32'>
                                    {
                                        item.employee.photo ?
                                        <img src={ `${ endpoint }storage/${ item.employee.photo }` } alt='' /> :
                                        item.employee.first_name.charAt(0)
                                    }
                                    </div>
                                </td>
                                <td>{ item.employee.last_name + " " + item.employee.first_name }</td>
                                <td>{ item.task === 'SORTING' ? 'Triage' : (item.task === 'CUTTING' ? 'Coupe' : (item.task === 'SORTIN_AFTER_CUTTING' ? 'Triage après coupe' : (item.task === 'CLEANING' ? 'Nettoyage' : (item.task === 'FINAL_INSPECTION' ? 'Vérification finale' : "Mise en boîte")))) }</td>
                                { item.task === 'SORTING' && <td className='text-center'>F: { item.quantity_short }</td> }
                                <td className='text-center' colSpan={ item.task === 'SORTING' ? 1 : 2}>{ item.task === 'SORTING' ? 'L: ' : ''}{ item.quantity_long }</td>
                                { item.task === 'SORTING' && <td className='text-center'>F: { item.waste_short }</td> }
                                <td className='text-center' colSpan={ item.task === 'SORTING' ? 1 : 2}>{ item.task === 'SORTING' ? 'L: ' : ''}{ item.waste_long ?? '-' }</td>
                                <td>{ item.rambo.code }</td>
                                <td className='text-end'>
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                            e.stopPropagation();
                                            setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button onClick={ () => {
                                                setModal("details-task-rambo");
                                                setActionModal(null);
                                                setTaskRambo(item);
                                            } }><i className='fa fa-eye'></i> Voir les détails</button></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setTaskRambo(item);
                                                setModal("update");
                                            } }><i className='fa fa-edit'></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        )
                        }) }
                    </tbody>
                </table>
            </div>
            </> : <>
            { config &&
            <div className='box p-3'>
                <Line data={ config } height={ 60  } />
            </div> }
            
            { data && 
            <div className='box' style={{ overflowX: "auto" }}>
                <table className='table table-striped' style={{ width: "auto" }}>
                    <thead>
                        <tr>
                            <th width="160">Tâche</th>
                            { data.dates.map((date, index) => {
                                return(
                                    <th key={ index }>{ dateFormat(date, 'ddmm') }</th>
                                )
                            }) }
                        </tr>
                    </thead>
                    <tbody>
                        { Object.values(data.data['SORTING'] || {}).length > 0 && 
                        <tr>
                            <th>{ getLabel('SORTING') }</th>
                            { Object.values(data.data['SORTING'] || {}).map((element, index) => {
                                return(
                                    <td key={ index } style={{ cursor: "pointer", textAlign: "center" }} onClick={ () => getDetails('SORTING', data.dates[index], element) }>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(element) }</td>
                                )
                            }) }
                        </tr> }
                        { Object.values(data.data['CUTTING'] || {}).length > 0 && 
                        <tr>
                            <th>{ getLabel('CUTTING') }</th>
                            { Object.values(data.data['CUTTING'] || {}).map((element, index) => {
                                return(
                                    <td key={ index } style={{ cursor: "pointer", textAlign: "center" }} onClick={ () => getDetails('SORTING', data.dates[index], element) }>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(element) }</td>
                                )
                            }) }
                        </tr> }
                        { Object.values(data.data['SORTING_AFTER_CUTTING'] || {}).length > 0 && 
                        <tr>
                            <th>{ getLabel('SORTING_AFTER_CUTTING') }</th>
                            { Object.values(data.data['SORTING_AFTER_CUTTING'] || {}).map((element, index) => {
                                return(
                                    <td key={ index } style={{ cursor: "pointer", textAlign: "center" }} onClick={ () => getDetails('SORTING', data.dates[index], element) }>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(element) }</td>
                                )
                            }) }
                        </tr> }
                        { Object.values(data.data['CLEANING'] || {}).length > 0 && 
                        <tr>
                            <th>{ getLabel('CLEANING') }</th>
                            { Object.values(data.data['CLEANING'] || {}).map((element, index) => {
                                return(
                                    <td key={ index } style={{ cursor: "pointer", textAlign: "center" }} onClick={ () => getDetails('SORTING', data.dates[index], element) }>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(element) }</td>
                                )
                            }) }
                        </tr> }
                        { Object.values(data.data['FINAL_INSPECTION'] || {}).length > 0 && 
                        <tr>
                            <th>{ getLabel('FINAL_INSPECTION') }</th>
                            { Object.values(data.data['FINAL_INSPECTION'] || {}).map((element, index) => {
                                return(
                                    <td key={ index } style={{ cursor: "pointer", textAlign: "center" }} onClick={ () => getDetails('SORTING', data.dates[index], element) }>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(element) }</td>
                                )
                            }) }
                        </tr> }
                        { Object.values(data.data['BOXING'] || {}).length > 0 && 
                        <tr>
                            <th>{ getLabel('BOXING') }</th>
                            { Object.values(data.data['BOXING'] || {}).map((element, index) => {
                                return(
                                    <td key={ index } style={{ cursor: "pointer", textAlign: "center" }} onClick={ () => getDetails('SORTING', data.dates[index], element) }>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(element) }</td>
                                )
                            }) }
                        </tr> }
                    </tbody>
                </table>
            </div> }
            </> }
        </HelmetProvider>
    )
}
